<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <!-- <h2 class="main-content-title tx-18 mg-b-5">Subject : Computer Science</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">ID: 198821 </li>
                            </ol> -->
                            <h2 class="main-content-title tx-18 mg-b-5">Paper Evaluation</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">ID: 198821 </li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                   >
                                   Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- list of QP start  -->
                
                    <!-- list of QP end  -->
                    <!-- add of QP start  -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate>
                            <div class="col-lg-12 col-md-12">
    
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row clearfix minheight">
                                            <div class="col-sm-1 border" >
                                                <div class="row">
                                                    <div class="col-sm-6" *ngFor="let f of buttton">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloricon" (click)="handleButtonClick(f.name)">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse ">{{f.name}}</strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                </div>  
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite" (click)="handleButtonClickOthers('✔')">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgreen">✔</strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite" (click)="handleButtonClickOthers('X')">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgred">X</strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite" (click)="handleButtonClickOthers('T')">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgblack">T</strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite" >
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgblack">
                                                                     <i class="fa fa-eye"></i>
                                                                    </strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgblack">
                                                                     <i class="fa fa-pencil"></i>
                                                                    </strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite">
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgblack">
                                                                     <i class="fa fa-refresh"></i>
                                                                    </strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="justify-content-center">
                                                            <span class="fa-stack  mb-2 mt-2 iconf primarycoloriconwhite" >
                                                                <i class="fas fa-circle fa-stack-2x "></i>
                                                                <strong class="fa-stack-1x fa-inverse cgblack">
                                                                     <i class="fa fa-trash-o"></i>
                                                                    </strong>
                                                              </span>
                                                        </div>
                                                    </div>
                                                </div>   
                                            </div>
                                            <div class="col-sm-6">
                                                <!-- <div #container>
                                                    <img src="../../assets/images/QP.jpeg" alt="Image Description" (click)="handleImageClick($event)">
                                                    <canvas #canvas></canvas>
                                                  </div> -->
                                                  <div #container>
                                                    <div>
                                                      <img src="../../assets/images/QP.jpeg" alt="Image Description" (click)="handleImageClick($event)">
                                                      <canvas #canvas></canvas>
                                                    </div>
                                                  </div>
                                               <!--  <div>
                                                    <img src="../../assets/images/QP.jpeg" alt="Image Description" (click)="handleImageClick($event)">
                                                    <canvas #canvas></canvas>
                                                  </div>
                                                <div #container>
                                                    <img src="../../assets/images/QP.jpeg" alt="Image Description" (click)="handleImageClick($event)">
                                                    <div *ngFor="let coordinate of pinCoordinates" [style.left]="coordinate.x + 'px'" [style.top]="coordinate.y + 'px'" class="value-element">{{ coordinate.value }}</div> 
                                                
                                                    <img src="../../assets/images/QP.jpeg" alt="Image Description" (click)="handleImageClick($event)">
                                                    <div *ngFor="let coordinate of pinCoordinates" [style.left.px]="coordinate.x" [style.top.px]="coordinate.y" class="value-element">{{ coordinate.value }}</div> 
                                                   </div> 
                                             <img src="../../assets/images/QP.jpeg"  alt="Image Description" (click)="handleImageClick($event)">
                                                <canvas #canvas></canvas>
                                                <canvas *ngFor="let coordinate of pinCoordinates" [style.left.px]="coordinate.x - 10" [style.top.px]="coordinate.y - 10"></canvas>  -->
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="table-responsive">
                                                    <table id="datatable"
                                                        class="table table-striped table-bordered text-nowrap text-left">
                                                        <thead>
                                                            <tr>
                                                                <th class="f600">
                                                                   Questions
                                                                </th>
                                                                <th class="f600">
                                                                    Out Of
                                                                </th>
                                                                <th>Score</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="table_data" *ngIf="questionmapermaster.length > 0">
                                                            <tr *ngFor="let QP of questionmapermaster;" (click)="QPselection(QP)">
                
                                                                <td> {{QP.Ques}} </td>
                                                                <td>{{QP.QM}} </td>
                                                                <td >
                                                                    {{QP.score}}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="row border">
                                                    <button type="button" class="btn btn-primary my-2 btn-icon-text ">
                                                        Calculate Total Score
                                                    </button>
                                                    <div class="col-sm-6">
                                                        <button type="button" class="btn btn-primary my-2 btn-icon-text ">
                                                            Reject Paper
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <button type="button" class="btn btn-primary my-2 btn-icon-text ">
                                                            Finish Paper
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="row border" height="100vh">
                                                    <img [src]="selectedQP" (click)="opendialog(selectedQP)">
                                                </div>
                                                <div class="row border">
                                                    <div class=col-sm-12>
                                                        <h5>Total Pages : 16        Visited : 4      Not-Visited : 12 </h5>
                                                    </div>
                                                    <span *ngFor="let number of numbers" class="fa-stack mr-3 mb-2">
                                                        <i class="fas fa-circle fa-stack-2x "></i>
                                                        <strong class="fa-stack-1x fa-inverse">{{ number }}</strong>
                                                      </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
    </body>
    